import { CHANGE_LANGUAGE } from './types'

export const changeLanguage = (newLanguage) => {
  return {
    type: CHANGE_LANGUAGE,
    payload: newLanguage,
  }
}
